// extracted by mini-css-extract-plugin
module.exports = {"collapse":"_10677f0961ce700c8aebc4aa6e2d4b14-less","active":"edb4c215fdb063e507fa0a801e26d084-less","thin":"_64773413aecac0cf6baf76146c7ef85e-less"};